import { useLingui } from "@lingui/react";
import { Translate } from "@phosphor-icons/react";
import { Button, Popover, PopoverContent, PopoverTrigger } from "@reactive-resume/ui";
import { useState } from "react";

import { changeLanguage } from "../providers/locale";
import { LocaleCombobox } from "./locale-combobox";
import { useLanguages } from "../services/resume/translation";
import Flag from "react-world-flags";
import { cn } from "@reactive-resume/utils";

export const LocaleSwitch = ({ fullCountryName = false }: { fullCountryName?: boolean }) => {
  const { i18n } = useLingui();
  const [open, setOpen] = useState(false);
  const { languages } = useLanguages();

  const currentLanguage = languages.find((language) => language.locale === i18n.locale);
  let countryCode = "";
  const localeParts = i18n.locale.split("-");
  if (localeParts.length === 2) {
    countryCode = localeParts[1].toUpperCase();
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button size={fullCountryName ? "lg" : "icon"} variant={fullCountryName ? "link" : "ghost"}>
          {fullCountryName ? (
            <div className="flex items-center gap-2">
              <Flag code={countryCode} className="size-5 rounded!" />
              {currentLanguage?.name}
            </div>
          ) : (
            <Translate size={20} />
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className={cn("p-0", fullCountryName ? "light" : "")} align="end">
        <LocaleCombobox
          value={i18n.locale}
          onValueChange={async (locale) => {
            await changeLanguage(locale);
            setOpen(false);
          }}
        />
      </PopoverContent>
    </Popover>
  );
};
